import { FaCamera, FaKeyboard, FaVideo, FaCheckCircle, FaTimes, FaBarcode } from 'react-icons/fa';

const ScannerPanel = ({
  isManualEntry,
  isScanning,
  availableDevices,
  selectedDeviceId,
  onChangeSelectedDevice,
  toggleInputMode,
  manualTicketCode,
  onManualTicketChange,
  onManualSubmit,
  manualInputRef,
  videoRef,
  canvasRef,
  startScanner,
  scanResult,
}) => (
  <div className="scanner-container">
    <div className="scanner-toggle-wrapper">
      <button
        className={`toggle-button ${isManualEntry ? 'active' : ''}`}
        onClick={toggleInputMode}
      >
        {isManualEntry ? (
          <>
            <FaCamera /> Switch to Camera
          </>
        ) : (
          <>
            <FaKeyboard /> Switch to Manual Entry
          </>
        )}
      </button>
    </div>

    <div className="preview-section">
      {isManualEntry ? (
        <div className="manual-entry-container">
          <form onSubmit={onManualSubmit} className="manual-entry-form">
            <input
              ref={manualInputRef}
              type="text"
              value={manualTicketCode}
              onChange={(e) => onManualTicketChange(e.target.value)}
              placeholder="Enter ticket code"
              className="manual-input"
              autoFocus
            />
            <button
              type="submit"
              className="submit-button"
              disabled={!manualTicketCode.trim()}
            >
              Submit
            </button>
          </form>
          <p className="hint-text">Press Enter to submit</p>
        </div>
      ) : (
        <div className="camera-preview">
          <video
            ref={videoRef}
            id="video"
            className={`attendance-video ${isScanning ? '' : 'attendance-video--hidden'}`}
            playsInline
            muted
            autoPlay
          />
          <canvas ref={canvasRef} className="attendance-canvas" />
          {!isScanning && (
            <div className="camera-placeholder">
              <FaVideo className="attendance-camera-icon" />
              <p>Camera preview will appear here</p>
              <button className="start-button" onClick={startScanner}>
                <FaCamera /> Start Scanner
              </button>
            </div>
          )}
        </div>
      )}
    </div>

    {scanResult && (
      <div className={`scan-result ${scanResult.success ? 'success' : 'error'}`}>
        <div className="result-icon">
          {scanResult.success ? <FaCheckCircle /> : <FaTimes />}
        </div>
        <div className="result-details">
          <h3>{scanResult.success ? 'Success!' : 'Error'}</h3>
          <p>{scanResult.message}</p>
          <p className="ticket-code">
            <FaBarcode /> {scanResult.code}
          </p>
        </div>
      </div>
    )}
  </div>
);

export default ScannerPanel;
